import { z } from "zod";

// Define schema for the pricing form with currency field and estimate price
export const pricingFormSchema = z.object({
  priceArrangement: z.enum([
    "fixed-fee", 
    "price-cap", 
    "billable-hour", 
    "other"
  ], {
    required_error: "You need to select a pricing arrangement.",
  }),
  currency: z.string().min(1, {
    message: "Please select a currency",
  }),
  customCurrency: z.string().optional(),
  provideEstimate: z.boolean().optional(),
  estimateType: z.enum(["fixed", "range"]).optional(),
  estimatePrice: z.string().optional(),
  estimatePriceMin: z.string().optional(),
  estimatePriceMax: z.string().optional(),
});

// Define type for the form values
export type PricingFormValues = z.infer<typeof pricingFormSchema>;

// Default values for the forms
export const pricingDefaultValues: Partial<PricingFormValues> = {
  priceArrangement: undefined,
  currency: "",
  customCurrency: "",
  provideEstimate: false,
  estimateType: undefined,
  estimatePrice: "",
  estimatePriceMin: "",
  estimatePriceMax: "",
};

// Define list of common currencies
export const commonCurrencies = [
  { value: "usd", label: "US Dollar ($)", symbol: "$" },
  { value: "eur", label: "Euro (€)", symbol: "€" },
  { value: "gbp", label: "British Pound (£)", symbol: "£" },
  { value: "jpy", label: "Japanese Yen (¥)", symbol: "¥" },
  { value: "cny", label: "Chinese Yuan (¥)", symbol: "¥" },
  { value: "cad", label: "Canadian Dollar (C$)", symbol: "C$" },
  { value: "aud", label: "Australian Dollar (A$)", symbol: "A$" },
  { value: "inr", label: "Indian Rupee (₹)", symbol: "₹" },
  { value: "chf", label: "Swiss Franc (CHF)", symbol: "CHF" },
  { value: "other", label: "Other (specify)", symbol: "" },
];
